<template>
    <router-link v-bind:to="{ name: 'ItineraryDisplay' }" class="itinerary-item">
        <img src="assets/images/itinerary1.png" alt="Experience Canada Image" />

        <div class="itinerary__overlay">
            <div class="itinerary__destinations">1 Country, 7 Destinations</div>

            <div class="itinerary__details">
                <div class="flag"></div>
                <div class="itinerary__title">Experience Canada</div>
                <p class="itinerary__subtitle">Trip To Iqaluit In Nunavut A Canadian Arctic City</p>
            </div>

            <div class="itinerary__owner" v-on:click.prevent="openProfile">
                <img src="assets/images/avatar1.png" class="avatar" alt="Camelia Jenssen's avatar" />

                <div class="itinerary__owner__details">
                    <div class="itinerary__owner__name">Camelia Jenssen</div>
                    <div class="itinerary__owner__rank">PlanIt Top Blogger, Rank 13</div>
                </div>
            </div>

            <div class="itinerary__icons">
                <div class="like" v-on:click.prevent="updateLikes">
                    <i class="like-icon" v-bind:class="{ liked: isLiked }"></i> {{ likes }}
                </div>

                <div class="share">
                    <i class="share-icon"></i>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    import router from '../modules/router'

    export default {
        name: 'ItineraryItem',
        data: function() {
            return {
                isLiked: false,
                likes: Math.floor(Math.random() * (100 - 10)) + 10
            }
        },
        methods: {
            updateLikes: function() {
                if (!this.isLiked) this.likes++
                else this.likes--

                this.isLiked = !this.isLiked
            },
            openProfile: function() {
                router.push({ name: 'Profile' })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .itinerary-item {
        position: relative;
        display: inline-block;

        @media all and (min-width: $breakpoint + 1) {
            margin: 24px 18px;
            width: 367px;
            height: 337px;
        }

        @media all and (max-width: $breakpoint) {
            margin: 0;
            width: 100%;
            height: auto;
        }
    }

    .itinerary-item:not(:first-child) {

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .itinerary-item > img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;

        @media all and (max-width: $breakpoint) {
            height: calc(100% / 367 * 337);
        }
    }


    .itinerary__overlay {
        background-color: rgba(0, 0, 0, 0.7);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        color: #FFF;

        @media all and (max-width: $breakpoint) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 15px;
        }
    }


    .itinerary__destinations {
        margin-top: 46px;
        letter-spacing: 1.67px;
        text-transform: uppercase;
        text-align: center;
        font-size: 10px;
        opacity: 0.6925;

        @media all and (max-width: $breakpoint) {
            margin-top: 0;
        }
    }


    .itinerary__details {
        margin-top: 42px;
        text-align: center;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .flag {
        background: url('/assets/images/flag1.png') no-repeat center;
        background-size: contain;
        margin: 0 auto;
        width: 19px;
        height: 19px;
    }


    .itinerary__title {
        font-family: 'Georgia', sans-serif;
        font-weight: normal;
        font-size: 24px;

        @media all and (max-width: $breakpoint) {
            font-size: 16px;
        }
    }


    .itinerary__subtitle {
        margin-top: 5px;
        font-size: 12px;
        opacity: 0.6925;
    }


    .itinerary__owner {
        display: flex;
        align-items: center;
        margin: 38px auto 0;
        width: max-content;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .itinerary__owner .avatar {
        width: 28px;
        height: 28px;
    }


    .itinerary__owner__details {
        margin-left: 7px;
    }


    .itinerary__owner__name {
        font-weight: $heavy;
        font-size: 10px;
        color: $accent;
    }


    .itinerary__owner__rank {
        font-size: 7px;
    }


    .itinerary__icons {
        display: flex;
        position: absolute;

        @media all and (min-width: $breakpoint + 1) {
            right: 33px;
            bottom: 25px;
        }

        @media all and (max-width: $breakpoint) {
            right: 15px;
            bottom: 15px;
        }
    }


    .itinerary__icons > div {
        display: flex;
        align-items: flex-end;
        cursor: pointer;
    }

    .itinerary__icons > div:not(:first-child) {
        margin-left: 24px;

        @media all and (max-width: $breakpoint) {
            margin-left: 15px;
        }
    }


    .like-icon {
        margin-right: 5px;
    }
</style>

